import React, { useState } from "react"
import { IRelease } from "../../interfaces/IRelease"
import { IChangeType } from "../../interfaces/IChangeType";
import { ReleaseForm } from "./ReleaseForm";
import { Alert, Grid } from "@mui/material";
import { ChangeSite } from "./ChangeSite";
import { ReleasePreview } from "./ReleasePreview";

export interface IProps {
    currentRelease: IRelease;
    setCurrentRelease: Function;
    changeTypeArray: IChangeType[];
}



export const getEmptyRelease = () => {
    return {
        created_at: "",
        descriptionHtml: "",
        id: -1,
        is_disabled: false,
        release_stage: "beta",
        releaseAt: "",
        title: "",
        changes: []
    } as IRelease
}


export const ReleaseEdit: React.FC<IProps> = ({currentRelease, setCurrentRelease, changeTypeArray}) => {
    const [orgRelease] = useState(currentRelease);

    if (currentRelease.id < 0) {
        return(
            <ReleaseForm
                currentRelease={currentRelease}
                setCurrentRelease={setCurrentRelease}
            />
        )
    } else {
        return(
            <Grid container spacing={2}>
                {orgRelease.is_disabled === true &&
                    <Grid item xs={12}>
                        <Alert severity="warning">
                            Diese Veröffentlichung ist bereits freigegeben — Änderungen sind
                            für die Instanzen der eingestellten Release-Stufe sofort sichtbar.
                            Für das Weiterreichen an die nächste Stufe genügt es, die
                            Release-Stufe zu ändern.
                        </Alert>
                    </Grid>
                }
                <Grid item xs={12} lg={7}>
                    <ReleaseForm
                        currentRelease={currentRelease}
                        setCurrentRelease={setCurrentRelease}
                    />
                    <ChangeSite
                        currentRelease={currentRelease}
                        setCurrentRelease={setCurrentRelease}
                        changeTypeArray={changeTypeArray}
                    />
                </Grid>
                <Grid item xs={12} lg={5}>
                    <ReleasePreview
                        currentRelease={currentRelease}
                        changeTypeArray={changeTypeArray}
                    />
                </Grid>
            </Grid>
        )
    }

}
